import VideoPlayerModal from "../../../ui/modals/VideoPlayerModal";
import React from "react";
import Image from "react-bootstrap/Image";
import {Link} from "react-router-dom";

class RecentAddedVideosModal extends VideoPlayerModal{
    /**
     * Renders the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        const {title, description, avatar, playerProfileLink, playerProfileText} = this.props;

        return (
            <React.Fragment>
                <div className="avatar-caption">
                    <div className="avatar-container">
                        <Image className="avatar" roundedCircle={true} src={avatar}/>
                    </div>
                    <div className="text-container">
                        <div className="title"> {title} </div>
                        <div className="description"> {description} </div>
                    </div>
                    <Link to={playerProfileLink} className="link"> {playerProfileText} </Link>
                </div>

                {this.renderVideoPlayer()}
            </React.Fragment>
        );
    };
}


export default RecentAddedVideosModal;
